import {useLayoutEffect, useState} from "react";
import {createPortal} from "react-dom";

export function Portal({ children }) {
  const [container] = useState(document.createElement("div"));

  useLayoutEffect(() => {
    const portalRoot = document.getElementById("account-portal-root");
    portalRoot.appendChild(container);

    return function cleanup() {
      portalRoot.removeChild(container);
    };
  }, [container]);
  return createPortal(children, container);
}